import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReportsMonitoringContainer from '../../containers/reports/Monitoring';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { sortStationTable, doesStationMatchFilter } from '../../libs/utility';

//- material-ui
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Paper from '@material-ui/core/Paper';
//import Button from '@material-ui/core/Button';
//import IconButton from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import UpIcon from '@material-ui/icons/ArrowDropUp';
import DownIcon from '@material-ui/icons/ArrowDropDown';

import { getSharedStyles } from '../../themes';
import InitialLoading from '../../components/InitialLoading';
import SaleCell from '../../components/SaleCell';
const styles = (theme) => ({
	...getSharedStyles(theme),
	paper: {
		height: 600,
		width: '100%',
		overflowX: 'auto',
		//minHeight : 500,
		//marginBottom: 20,
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 20,
		[theme.breakpoints.up('sm')]: {
			padding: '20px 20px 20px 20px',
		},
	},
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	reportInfo: {
		textAlign: 'left',
		padding: '10px 10px',
	},
	warning: {
		color: '#FFC107',
		width: 16,
		height: 16,
		paddingRight: 3,
	},
	error: {
		color: '#e53935',
		width: 20,
		height: 20,
		paddingRight: 3,
	},
	question: {
		color: '#91b5b9',
		width: 20,
		height: 20,
		paddingRight: 3,
	},
	info: {
		color: '#2196F3',
		width: 20,
		height: 20,
		paddingRight: 3,
	},
	upDownIcon: {
		marginTop: -15,
		bottom: -6,
		width: 28,
		height: 22,
		position: 'relative',
	},
	diffUp: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	diffDown: {
		fontWeight: 900,
		color: '#FF500F',
	},
	label: {},
	subLabel: {
		fontWeight: 200,
		color: '#999',
		fontSize: 13,
	},
	value: {
		fontWeight: 600,
	},
	stats: {
		padding: '10px 10px 20px 10px',
		borderBottom: '1px solid #ddd',
		marginBottom: 10,
	},
});

const columnData = [
	{ id: 'count', numeric: false, label: '#', padding: 'checkbox' },
	{
		id: 'number',
		numeric: false,
		label: 'Station',
		style: { top: -20 },
	},
	{
		id: 'lastMonthTotalSales',
		numeric: true,
		label: (
			<div>
				Prior Month
				<br />
				Total Sales
			</div>
		),
		style: { top: -20 },
	},
	{
		id: 'currentMonthTotalSales',
		numeric: true,
		label: (
			<div>
				Current Month
				<br />
				Total Sales
			</div>
		),
		style: { top: -20 },
	},
	{
		id: 'lastMonthDailyAverage',
		numeric: true,
		label: (
			<div>
				Prior Month
				<br />
				Daily Avg
			</div>
		),
		style: { top: -20 },
	},
	{
		id: 'currentMonthDailyAverage',
		numeric: true,
		label: (
			<div>
				Current Month
				<br />
				Daily Avg
			</div>
		),
		style: { top: -20 },
	},
	{
		id: 'diff',
		numeric: true,
		label: 'Diff',
		style: { top: -20 },
	},
];

const productTypeToDisplay = {
	e85: 'E85',
	//bioDiesel : 'Bio-Diesel'
};

function getYearMonth({ date }) {
	return `${date.year()}_${date.month()}`;
}
//const stationIdsToIgnoreFromStats = [30]; //Rancho
const stationIdsToIgnoreFromStats = []; //Rancho

class Monitoring extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'asc',
			orderBy: 'number',
			order2: 'asc',
			orderBy2: 'number',
			search: '',
		};
		this.currentMonth = moment();
		this.lastMonth = moment().subtract(1, 'month');

		this.handleRowClick = this.handleRowClick.bind(this);
		this.handleRequestSort = this.handleRequestSort.bind(this);
		this.handleRequestSort2 = this.handleRequestSort2.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}

	monthCheck({ date }) {
		const year = date.year();
		const month = date.month();
		const yearMonth = getYearMonth({ date });

		if (!this.props.salesByMonth[yearMonth]) {
			this.props.getMonthlySales({ params: { year, month, doNotShowInactive: true } });
		}
	}

	componentDidMount() {
		this.monthCheck({ date: this.currentMonth });
		this.monthCheck({ date: this.lastMonth });

		if (!this.props.tankDailySales) {
			this.props.getTankDailySales({
				params: {
					doNotShowInactive: true,
				},
			});
		}
	}

	handleSearch(event) {
		this.setState({ search: event.target.value });
	}

	handleRowClick(stationId, tankNumber) {
		this.props.history.push(`/reports/stationVolume/${stationId}/${tankNumber}`);
	}

	handleRequestSort(property) {
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	}

	handleRequestSort2(property) {
		const orderBy2 = property;
		let order2 = 'desc';

		if (this.state.orderBy2 === property && this.state.order2 === 'desc') {
			order2 = 'asc';
		}
		this.setState({ order2, orderBy2 });
	}

	render() {
		const { classes, salesByMonth, tankDailySales, stationMap, authUser } = this.props;

		if (!salesByMonth || !tankDailySales || !authUser || !stationMap) {
			return <InitialLoading />;
		}

		const currentYearMonth = getYearMonth({ date: this.currentMonth });
		const lastYearMonth = getYearMonth({ date: this.lastMonth });

		const currentMonthData = salesByMonth[currentYearMonth];
		const lastMonthData = salesByMonth[lastYearMonth];

		if (!currentMonthData || !lastMonthData) {
			return <div>Calculating monthly sales...</div>;
		}

		const { order, orderBy, order2, orderBy2, search } = this.state;
		//const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		const totalByProduct = {};
		_.keys(productTypeToDisplay).forEach((productType) => {
			totalByProduct[productType] = {
				currentMonth: { sales: [], dailyAverages: [] },
				lastMonth: { sales: [], dailyAverages: [] },
			};
		});

		const tankKey = (t) => {
			return `${t.stationId}_${t.tankNumber}`;
		};
		const currentByTank = _.keyBy(currentMonthData.tankDailySales, tankKey);
		const lastByTank = _.keyBy(lastMonthData.tankDailySales, tankKey);
		let currentAndLastSales = [];

		const forRow = (o, l) => {
			if (!o) {
				return '-';
			}
			return _.isNumber(o[l]) ? _.round(o[l]) : '-';
		};
		const forTotal = (n) => {
			return _.isNumber(n) ? _.round(n) : 0;
		};

		const previousAverages = [];
		const currentAverages = [];
		const diffs = [];
		let numberOfStationsUp = 0;
		let numberOfStationsDown = 0;
		let numberOfStationsNeutral = 0;
		let numberOfNewStations = 0;
		let numberOfStoppedReporting = 0;

		_.union(_.keys(currentByTank), _.keys(lastByTank)).forEach((stationTank) => {
			const c = currentByTank[stationTank];
			const l = lastByTank[stationTank];
			const a = c ? c : l;
			const { stationId } = a;

			if (_.includes(stationIdsToIgnoreFromStats, stationId)) {
				return;
			}

			const productType = a.productType;
			const currentMonthTotalSales = forRow(c, 'totalVolume');
			const currentMonthDailyAverage = forRow(c, 'dailyAverage');
			const lastMonthTotalSales = forRow(l, 'totalVolume');
			const lastMonthDailyAverage = forRow(l, 'dailyAverage');

			let diffIcon = '';
			let diffClass = '';
			let diff;

			//- Either we don't have numbers for last month or this month
			//- No data lst month but we have it this month. New station

			if (_.isFinite(currentMonthDailyAverage) && !_.isFinite(lastMonthDailyAverage)) {
				currentAverages.push(currentMonthDailyAverage);
				diff = '-';
				numberOfNewStations++;
			} else if (
				(!_.isFinite(currentMonthDailyAverage) || Number(currentMonthDailyAverage) === 0) &&
				_.isFinite(lastMonthDailyAverage)
			) {
				previousAverages.push(lastMonthDailyAverage);
				diff = '-';
				numberOfStoppedReporting++;
			} else {
				diff = _.round(currentMonthDailyAverage - lastMonthDailyAverage, 3);
				if (diff > 0) {
					diffIcon = <UpIcon className={classes.upDownIcon} />;
					diffClass = 'diffUp';
					numberOfStationsUp++;
				} else if (diff < 0) {
					diffIcon = <DownIcon className={classes.upDownIcon} />;
					diffClass = 'diffDown';
					numberOfStationsDown++;
				} else {
					numberOfStationsNeutral++;
				}
				diffs.push(diff);
				previousAverages.push(lastMonthDailyAverage);
				currentAverages.push(currentMonthDailyAverage);
			}

			currentAndLastSales.push({
				stationId: a.stationId,
				tankNumber: a.tankNumber,
				productType,
				currentMonthTotalSales,
				currentMonthDailyAverage,
				lastMonthTotalSales,
				lastMonthDailyAverage,
				diff,
				absDiff: _.isFinite(diff) ? Math.abs(diff) : '-',
				diffIcon,
				diffClass,
			});

			/** @namespace c.totalVolume **/
			/** @namespace c.dailyAverage **/
			if (c) {
				totalByProduct[productType].currentMonth.sales.push(forTotal(c.totalVolume));
				totalByProduct[productType].currentMonth.dailyAverages.push(forTotal(c.dailyAverage));
			}

			if (l) {
				totalByProduct[productType].lastMonth.sales.push(forTotal(l.totalVolume));
				totalByProduct[productType].lastMonth.dailyAverages.push(forTotal(l.dailyAverage));
			}
		});

		const averageDiff = _.round(_.mean(diffs), 2);

		let avgDiffIcon = '';
		let avgDiffClass = '';
		if (averageDiff > 0) {
			avgDiffIcon = <UpIcon className={classes.upDownIcon} />;
			avgDiffClass = 'diffUp';
		} else if (averageDiff < 0) {
			avgDiffIcon = <DownIcon className={classes.upDownIcon} />;
			avgDiffClass = 'diffDown';
		}

		const stats = [
			{
				label: `Average Prior Month Average`,
				subLabel: `Based on ${previousAverages.length} stations reporting`,
				value: _.round(_.mean(previousAverages)),
			},
			{
				label: `Average Current Month Average`,
				value: _.round(_.mean(currentAverages)),
				subLabel: `Based on ${currentAverages.length} stations reporting`,
			},
			{
				label: `Average Diff`,
				value: (
					<div className={classes[avgDiffClass]}>
						{avgDiffIcon} {averageDiff}
					</div>
				),
				subLabel: `Based on comparing ${diffs.length} stations`,
			},
		];
		const stats2 = [
			{
				label: `Number of Stations Up`,
				value: <span className={classes.diffUp}>{numberOfStationsUp}</span>,
			},
			{
				label: `Number of Stations Down`,
				value: <span className={classes.diffDown}>{numberOfStationsDown}</span>,
			},
			{
				label: `Number of Stations Neutral`,
				value: numberOfStationsNeutral,
			},
			{
				label: `Number of New Stations`,
				value: numberOfNewStations,
			},
			{
				label: `Number of Stations Stopped Reporting`,
				value: numberOfStoppedReporting,
			},
		];

		currentAndLastSales = currentAndLastSales.reduce((result, stationTank) => {
			const { tankNumber, stationId, productType } = stationTank;
			const station = stationMap[stationId];
			if (doesStationMatchFilter({ search, station }) === false) {
				return result;
			}

			const { number, name } = station;
			const productDisplay = productTypeToDisplay[productType];
			const row = _.merge(
				{
					id: stationId,
					number,
					name,
					rowClick: () => this.handleRowClick(stationId, tankNumber),
					station: (
						<div>
							<div>
								{number} - {name}
							</div>
							<div style={{ fontSize: 13, color: '#666' }}>
								{productDisplay} / Tank #{tankNumber}
							</div>
						</div>
					),
				},
				stationTank
			);

			result.push(row);
			return result;
		}, []);

		const monthlySalesRows = sortStationTable({
			rows: currentAndLastSales,
			orderBy: orderBy2,
			order: order2,
		});

		const dailySalesColumns = [
			{ id: 'count', numeric: false, label: '#', padding: 'checkbox' },
			{ id: 'number', numeric: false, label: 'Station', style: { top: -20 } },
			//{ id: 'productAndTank', numeric: false, label: 'Product / Tank', disablePadding : true },
		];

		const last10Days = [];
		_.range(1, 15).forEach((i) => {
			last10Days.push(moment().subtract(i, 'day'));
		});

		last10Days.forEach((date, i) => {
			const monthDay = date.format('MM/DD');
			const day = date.format('ddd');
			dailySalesColumns.push({
				id: `day${i}`,
				numeric: true,
				disablePadding: true,
				label: (
					<div style={{ textAlign: 'center' }}>
						{monthDay}
						<br />
						{day}
					</div>
				),
				style: { top: -20 },
			});

			if (i === 0) {
				dailySalesColumns.push({
					id: `day${i}Diff`,
					numeric: true,
					disablePadding: true,
					label: (
						<div style={{ textAlign: 'center' }}>
							Last Week
							<br />
							Compare
						</div>
					),
					style: { top: -20 },
				});
			}
		});

		const dailySales = tankDailySales.reduce((result, salesRow) => {
			const { stationId, tankNumber, productType } = salesRow;

			const station = stationMap[stationId];
			if (doesStationMatchFilter({ search, station }) === false) {
				return result;
			}
			const productDisplay = productTypeToDisplay[productType];
			const { number, name, stationIsNotActive } = station;
			if (stationIsNotActive) {
				return result;
			}

			const row = _.merge({
				stationId,
				id: stationId,
				number,
				name,
				station: (
					<div>
						<div>
							{number} - {name}
						</div>
						<div style={{ fontSize: 13, color: '#666' }}>
							{productDisplay} / Tank #{tankNumber}
						</div>
					</div>
				),
				tankNumber,
				rowClick: () => this.handleRowClick(stationId, tankNumber),
			});

			const lastDateMap = _.keyBy(salesRow.sales, (sale) => {
				return moment(sale.date).format('MM-DD');
			});

			last10Days.forEach((day, i) => {
				const dateKey = moment(day).format('MM-DD');
				const salesRow = _.get(lastDateMap, [dateKey], {});
				row[`day${i}`] = _.isNumber(salesRow.volume) ? salesRow.volume : '-';

				/** @namespace salesRow.note **/
				/** @namespace salesRow.saleHigh **/

				const contents = [];
				[
					'warning',
					'note',
					'error',
					'info',
					'question',
					'saleHigh',
					'saleVeryHigh',
					'saleLow',
					'saleVeryLow',
				].forEach((s) => {
					if (!salesRow[s]) {
						return;
					}
					contents.push({ type: s, text: salesRow[s] });
				});

				row[`day${i}Display`] = <SaleCell salesRow={salesRow} />;

				//- 7 days ago
				const dateDiffKey = moment(day).subtract(1, 'week').format('MM-DD');
				const salesRowDiff = _.get(lastDateMap, [dateDiffKey], {});

				if (salesRow.volume && salesRowDiff.volume) {
					let diffIcon, diffClass;

					const diff = _.round(salesRow.volume - salesRowDiff.volume, 3);
					if (diff > 0) {
						diffIcon = <UpIcon className={classes.upDownIcon} />;
						diffClass = 'diffUp';
						numberOfStationsUp++;
					} else if (diff < 0) {
						diffIcon = <DownIcon className={classes.upDownIcon} />;
						diffClass = 'diffDown';
						numberOfStationsDown++;
					} else {
						numberOfStationsNeutral++;
					}
					const diffDisplay = _.isFinite(diff) ? Math.abs(diff) : '-';
					row[`day${i}Diff`] = diff;
					row[`day${i}DiffIcon`] = diffIcon;
					row[`day${i}DiffClass`] = diffClass;
					row[`day${i}DiffDisplay`] = diffDisplay;
				} else {
					row[`day${i}Diff`] = '-';
					row[`day${i}DiffDisplay`] = '-';
				}
			});

			result.push(row);
			return result;
		}, []);
		const dailySalesRows = sortStationTable({ rows: dailySales, orderBy, order });
		const stationCount = _.keys(_.keyBy(dailySalesRows, tankKey)).length;
		const diffCell = { backgroundColor: '#f5f5f5', paddingRight: 3 };

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Typography variant="h5" align="left" gutterBottom className={classes.title}>
						<span>Station Daily Sales</span>
						<TextField
							className={classes.formControl}
							value={this.state.search}
							onChange={(event) => this.handleSearch(event)}
							label="Type to search"
							fullWidth
						/>
					</Typography>
				</Grid>

				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<div className={classes.reportInfo}>
							Total Reporting Stations :<span style={{ fontWeight: 900 }}> {stationCount}</span>
						</div>

						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={dailySalesColumns}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{dailySalesRows.map((n, i) => {
									/** @namespace n.day0Display **/
									/** @namespace n.day0DiffIcon **/
									/** @namespace n.day0DiffClass **/
									/** @namespace n.day0DiffDisplay **/
									/** @namespace n.day1Display **/
									/** @namespace n.day2Display **/
									/** @namespace n.day3Display **/
									/** @namespace n.day4Display **/
									/** @namespace n.day5Display **/
									/** @namespace n.day6Display **/
									/** @namespace n.day7Display **/
									/** @namespace n.day8Display **/
									/** @namespace n.day9Display **/
									return (
										<TableRow
											hover
											className={classes.row}
											style={{ backgroundColor: n.isSelected ? '#ef9a9a' : undefined }}
											key={`${n.id}_${n.tankNumber}`}
										>
											<TableCell onClick={n.rowClick}>{i + 1}</TableCell>
											<TableCell onClick={n.rowClick}>{n.station}</TableCell>
											<TableCell
												style={diffCell}
												onClick={n.rowClick}
												padding={'none'}
												align="right"
											>
												{n.day0Display}
											</TableCell>

											<TableCell
												onClick={n.rowClick}
												align="right"
												className={classes[n.day0DiffClass]}
												style={diffCell}
											>
												{n.day0DiffIcon} {n.day0DiffDisplay}
											</TableCell>

											{last10Days.map((day, i) => {
												if (i === 0) {
													return null;
												}
												return (
													<TableCell key={`day${i}Display`} onClick={n.rowClick} align="right">
														{n[`day${i}Display`]}
													</TableCell>
												);
											})}
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</Paper>
				</Grid>

				<Grid item xs={12}>
					<Typography variant="h5" align="left" gutterBottom className={classes.title}>
						<span>Station Monthly Sales</span>
						<TextField
							className={classes.formControl}
							value={this.state.search}
							onChange={(event) => this.handleSearch(event)}
							label="Type to search"
							fullWidth
						/>
					</Typography>
				</Grid>

				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<div className={classes.stats}>
							<Grid container spacing={2}>
								<Grid item xs={12} md={6}>
									{stats.map((stat, i) => {
										return (
											<Grid key={i} container spacing={2}>
												<Grid item lg={7} md={7} xs={6} style={{ textAlign: 'left' }}>
													<div className={classes.label}>{stat.label}</div>
													{!!stat.subLabel && (
														<div className={classes.subLabel}>{stat.subLabel}</div>
													)}
												</Grid>
												<Grid item lg={3} md={4} xs={4} style={{ textAlign: 'right' }}>
													<span className={classes.value}>{stat.value || '-'}</span>
												</Grid>
											</Grid>
										);
									})}
								</Grid>
								<Grid item xs={12} md={6}>
									{stats2.map((stat, i) => {
										return (
											<Grid key={i} container spacing={2}>
												<Grid item lg={6} md={6} xs={6} style={{ textAlign: 'left' }}>
													<span className={classes.label}>{stat.label}</span>
												</Grid>
												<Grid item lg={2} md={3} xs={4} style={{ textAlign: 'right' }}>
													<span className={classes.value}>{stat.value || '-'}</span>
												</Grid>
											</Grid>
										);
									})}
								</Grid>
							</Grid>
						</div>

						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={columnData}
								order={order2}
								orderBy={orderBy2}
								onRequestSort={this.handleRequestSort2}
							/>
							<TableBody>
								{monthlySalesRows.map((n, i) => {
									return (
										<TableRow
											hover
											className={classes.row}
											style={{ backgroundColor: n.isSelected ? '#ef9a9a' : undefined }}
											key={`${n.id}_${n.tankNumber}`}
										>
											<TableCell onClick={n.rowClick}>{i + 1}</TableCell>
											<TableCell onClick={n.rowClick}>{n.station}</TableCell>
											<TableCell onClick={n.rowClick} align="right">
												{n.lastMonthTotalSales}
											</TableCell>
											<TableCell onClick={n.rowClick} align="right">
												{n.currentMonthTotalSales}
											</TableCell>
											<TableCell onClick={n.rowClick} align="right">
												{n.lastMonthDailyAverage}
											</TableCell>
											<TableCell onClick={n.rowClick} align="right">
												{n.currentMonthDailyAverage}
											</TableCell>
											<TableCell
												onClick={n.rowClick}
												align="right"
												className={classes[n.diffClass]}
											>
												{n.diffIcon} {n.absDiff}
											</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

Monitoring.propTypes = {
	classes: PropTypes.object.isRequired,
	getMonthlySales: PropTypes.func.isRequired,
	getTankDailySales: PropTypes.func.isRequired,
	salesByMonth: PropTypes.object,
	tankDailySales: PropTypes.array,
	stationMap: PropTypes.object,
	order: PropTypes.string,
	orderBy: PropTypes.string,

	order2: PropTypes.string,
	orderBy2: PropTypes.string,

	history: PropTypes.object,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), ReportsMonitoringContainer])(Monitoring);
